// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","cardContentWrapper":"NoteEditingPage_cardContentWrapper__TIsTa"};